import React, { Component } from "react";
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import * as util from './commons';
import { Col, Form, Row } from 'react-bootstrap';

export default class ShowConfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }
    thisDialogFooter = () => {
        return(
            <>
            <Row className="justify-content-md-center" style={{ direction: "ltr", textAlign:"right" }}>
                <Col style={{textAlign:"rigth"}}>
                    <Button label="انصراف" icon="pi pi-times" outlined onClick={()=>this.props.onReject()} iconPos="right" />
                </Col>
                <Col style={{textAlign:"left"}}>
                    <Button label="تائید" icon="pi pi-check" onClick={()=>this.props.onAccept()} loading={this.props.loading} iconPos="right" severity="danger" />
                </Col>                                       
            </Row>
            </>
        )
    }
    render(){
        var textAlign = "right";
        return(
            <Dialog visible={this.props.visible} style={{ width: '45rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            modal className="p-fluid" footer={() => this.thisDialogFooter()} onHide={this.props.onReject} header={this.props.caption}
            >
                <table style={{marginTop:"10px", width:"100%"}}>
                    <tbody>
                    <tr>
                        <td style={{width:"100px", textAlign:"center"}}>
                            <img src={require("./../../src/lib/images/warning-icon.png")} alt={this.props.caption} width="72" height="72" />
                        </td>
                        <td style={{padding:"5px", textAlign:textAlign, verticalAlign:"middle"}}>
                            {this.props.message}
                        </td>
                    </tr>
                    </tbody>
                </table>

            </Dialog>

        );
    }
}
        